import "./partnerSummary.scss";

export default function PartnerSummary(props: {
  summaries: {
    iconUrl: string;
    textArr: string[];
  }[];
}) {
  return (
    <>
      {props.summaries.length > 0 && (
        <div className={`partner-summaries-wrap`}>
          {props.summaries.map((item, idx) => (
            <SummaryItem key={idx} iconUrl={item.iconUrl} textArr={item.textArr} />
          ))}
        </div>
      )}
    </>
  );
}

function SummaryItem(props: { iconUrl: string; textArr: string[] }) {
  return (
    <div className="summary-item">
      {/* <i className="icon" style={{ backgroundImage: `url(${props.iconUrl})` }}></i> */}
      <img src={props.iconUrl} alt="" width={18} height={18} />

      <div className="text-box">
        {props.textArr.map((text, idx) => (
          <p key={idx} className="text">
            {text}
          </p>
        ))}
      </div>
    </div>
  );
}
